module.exports = __webpack_public_path__ + "static/media/twitter.7fd39922.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/twitter.svg
// module id = 355
// module chunks = 1